<template>
  <v-icon :class="classes" v-text="icon"/>
</template>

<script>
export default {
  name: 'CFeatureIcon',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required: true
    }
  },
  computed: {
    classes () {
      const dark = this.isDarkColor('primary')

      return {
        // 共通クラス
        'rounded-circle': true,
        'pa-1': true,

        // checked
        primary: this.checked,
        'white--text': this.checked,

        // unchecked
        grey: !this.checked,
        'lighten-2': !this.checked && !dark,
        'darken-3': !this.checked && dark,
        'grey--text': !this.checked,
        'text--darken-1': !this.checked && dark
      }
    }
  }
}
</script>
